import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorImage from './SetupError.png';
import styles from './SetupError.scss';

export default function SetupError() {
  const { t } = useTranslation();
  const heading = t('Setup.Error.Heading', { defaultValue: 'Recording device not available' });
  const body = t('Setup.Error.Body', {
    defaultValue: 'Check your browser settings to ensure access is allowed for both your camera and microphone'
  });
  const altText = `${heading}. ${body}.`;

  return (
    <div className={styles.setupError}>
      <img src={ErrorImage} alt={altText} data-testid="setupErrorImage" />
      <div className={styles.heading} data-testid="setupErrorHeading">
        {heading}
      </div>
      <div className={styles.body} data-testid="setupErrorBody">
        {body}
      </div>
    </div>
  );
}
